<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-icon="fas fa-calendar"
        @click.native="menu = true"
        readonly
      >
        <template v-slot:append>
          <v-btn rounded small @click="date=null" color="secondary">Clear</v-btn>
        </template>
      </v-text-field>
    </template>
    <v-date-picker v-model="date" @input="menu = false" style="width: 100%" :allowed-dates="allowedDates"></v-date-picker>
  </v-menu>
</template>

<script>
    export default {
        name: "DateSelector",
        props: {
            label: {
                type: String,
                default: "Date"
            },
            value: String,
            allowedDates: Function
        },
        data() {
            return {
                menu: false,
                date: null,
            }
        },
        mounted() {
          this.date = this.value;
        },
        watch: {
              date(val) {
                  this.$emit('input', val);
              }
          }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/DateSelector.vue